const {
  tracking,
  customer,
  product,
  routePlanner,
  inventory,
} = require("@/networking/urlmanager");
const { routeEngine } = require("@/networking/routeEngine");
const axios = require("axios");
const { getTokenSafely, validateToken } = require("./recomendation/tokenHelper");

const productCache = {
  data: null,
  timestamp: 0,
};

const customerCache = {
  data: null,
  timestamp: 0,
};

const customerExpectedProductsCache = {
  data: null,
  timestamp: 0,
};



async function getLocationAll(token) {
  // Token validation - Eğer token geçersizse localStorage'dan oku
  let validToken = token;

  // Eğer parametre olarak gelen token geçersizse, localStorage'dan al
  if (!token || token === 'undefined' || token === 'null' || typeof token !== 'string' || token.trim() === '') {
    console.warn('⚠️ [getLocationAll] Parametre token geçersiz, localStorage\'dan okunuyor...');
    validToken = getTokenSafely();
  }

  // Artık validToken'ı validate et
  validateToken(validToken, 'getLocationAll');

  try {
    const result = await axios.get(tracking.getAll + "?isActive=true", {
      headers: {
        Authorization: "Bareer " + validToken,
      },
    });

    const data = result.data.data
      .map((item) => ({
        ...item,
        isAvailable: false,
        // inventory bilgisi backend'den geliyorsa koru
        inventory: item.inventory || []
      }));
      // .filter((item) => item.driverTC); // Transfer için tüm araçları göster

    return data;
  } catch (error) {
    console.error("Araç verileri getirilemedi:", error.message);

    // Kullanıcıya anlamlı bir hata mesajı göstermek için alert yerine console uyarısı
    return [];
  }
}
async function getCustomers(token) {
  // Token validation - Eğer token geçersizse localStorage'dan oku
  let validToken = token;

  // Eğer parametre olarak gelen token geçersizse, localStorage'dan al
  if (!token || token === 'undefined' || token === 'null' || typeof token !== 'string' || token.trim() === '') {
    console.warn('⚠️ [getCustomers] Parametre token geçersiz, localStorage\'dan okunuyor...');
    validToken = getTokenSafely();
  }

  // Artık validToken'ı validate et
  validateToken(validToken, 'getCustomers');

  const cacheDuration = 300000; // 1 dakika = 60,000 ms
  const currentTime = Date.now();

  // Eğer cache'de veri varsa ve süresi dolmadıysa, cache'i kullan
  if (customerCache.data && currentTime - customerCache.timestamp < cacheDuration) {
    return customerCache.data;
  }

  try {
    const result = await axios.get(customer.getAllNotPagination, {
      headers: {
        Authorization: "Bareer " + validToken,
      },
    });

    const data = Array.isArray(result.data.data) ? result.data.data : [];

    // Yeni veriyi cache'e kaydet
    customerCache.data = data;
    customerCache.timestamp = currentTime;

    return data;
  } catch (error) {
    console.log(error.response);
    return [];
  }
}
async function getProducts(token,cacheReset=false) {
  // Token validation - Eğer token geçersizse localStorage'dan oku
  let validToken = token;

  // Eğer parametre olarak gelen token geçersizse, localStorage'dan al
  if (!token || token === 'undefined' || token === 'null' || typeof token !== 'string' || token.trim() === '') {
    console.warn('⚠️ [getProducts] Parametre token geçersiz, localStorage\'dan okunuyor...');
    validToken = getTokenSafely();
  }

  // Artık validToken'ı validate et
  validateToken(validToken, 'getProducts');

  const cacheDuration = 300000; // 1 dakika = 60,000 ms
  const currentTime = Date.now();

  // Eğer cache'de veri varsa ve süresi dolmadıysa, cache'i kullan
  if (productCache.data && currentTime - productCache.timestamp < cacheDuration && !cacheReset) {
    return productCache.data;
  }

  try {
    const result = await axios.get(product.getWithFilterAll, {
      headers: {
        Authorization: "Bareer " + validToken,
      },
    });

    const data = Array.isArray(result.data.data) ? result.data.data : [];

    // Yeni veriyi cache'e kaydet
    productCache.data = data;
    productCache.timestamp = currentTime;

    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
}
async function getRoute(
  from = { lat: 0, lng: 0 },
  to = { lat: 0, lng: 0 },
  isAdr = false,
  token
) {
  try {
    if (from.lat == 0 || from.lng == 0 || to.lat == 0 || to.lng == 0) {
      console.log(
        "Başlangıç ve bitiş konumları boş olduğundan dolayı rota hesaplaması yapılamadı"
      );
      return;
    }

    const detail = await axios.post(
      routeEngine.generate,
      {
        from,
        to,
        waypoints: [],
        isToll: 1,
        routeType: "fast",
        shippedHazardousGoods: isAdr,
        isShip: 1,
        isAsphalt: 1,
        fuelRatio: 35,
        isPolyline: 1,
        vehicleTypeId: 5, // tır
        isApi: 1,
      },
      {
        headers: {
          Authorization: "Bareer " + this.$store.state.routeEngineToken,
        },
      }
    );
    return detail.data.data;
    // return detail.data.data[0];
  } catch (error) {
    console.warn(error);
    return null;
  }
}


async function getCustomerExpectedProducts(token, cacheReset = false) {
  const cacheDuration = 300000; // 5 dakika
  const currentTime = Date.now();

  // Cache kontrolü
  if (customerExpectedProductsCache.data &&
      currentTime - customerExpectedProductsCache.timestamp < cacheDuration &&
      !cacheReset) {
    return customerExpectedProductsCache.data;
  }

  try {
    const result = await axios.get(inventory.getCustomerExpectedProducts, {
      headers: {
        Authorization: "Bareer " + token,
      },
    });

    const data = result.data.data || {};

    // Yeni veriyi cache'e kaydet
    customerExpectedProductsCache.data = data;
    customerExpectedProductsCache.timestamp = currentTime;

    return data;
  } catch (error) {
    console.error("Müşteri beklenen ürünler getirilemedi - Detaylı hata:");
    console.error("Error message:", error.message);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    return {};
  }
}

// Cache temizleme fonksiyonları
function clearAllCaches() {
  customerCache.data = null;
  customerCache.timestamp = 0;
  productCache.data = null;
  productCache.timestamp = 0;
  customerExpectedProductsCache.data = null;
  customerExpectedProductsCache.timestamp = 0;
}

const yesNoOptions = [
  {
    id: 1,
    name: "Evet",
  },
  {
    id: 2,
    name: "Hayır",
  },
];
module.exports = {
  getLocationAll,
  getCustomers,
  getProducts,
  getRoute,
  getCustomerExpectedProducts,
  yesNoOptions,
  clearAllCaches,
  // Cache objeleri - dışarıdan erişim için
  customerExpectedProductsCache,
  productCache,
  customerCache
};
